/* eslint-disable */
export default {
  logged: '已記錄',
  unlogged: '未使用',
  faxNotSupported: '不支援記錄傳真。',
} as const;

// @key: @#@"logged"@#@ @source: @#@"Logged"@#@
// @key: @#@"unlogged"@#@ @source: @#@"Unworked"@#@
// @key: @#@"faxNotSupported"@#@ @source: @#@"To log fax is not supported."@#@
